"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var processors_1 = require("./processors");
var mainHander = function (event) {
    var context = { isHandled: false };
    processors_1.default.forEach(function (_) { return _(event, context); });
    if (!context.isHandled) {
        console.warn("The following event was not handled by the adobe analytics layer: ", event);
    }
};
exports.default = mainHander;
